module.exports = __webpack_public_path__ + "img/id.66be9749.png";